function PopUp({ children, size = "", className = "" }) {
	return (
		<div className={"popup " + size + " " + className}>
			<div className="container">{children}</div>
		</div>
	);
}

export default PopUp;
